import * as types from "@/store/mutation-types";
import {
  getPlanGrade,
  isLowerThanStarter,
  isLowerThanLight,
  isLowerThanStandard,
  isLowerThanPro,
  isLowerThanEnterprise
} from "@/utils/account";

/**
 * @fileoverview vueの動的コンポーネントの仕様を利用して、
 * storeに入れたコンポーネント名のコンポーネントを動的に読み込んで表示
 */

/**
 * [grede] 0:フリー, 1: ライト, 2:スタンダード, 3: プロ, 4:エンタープライズ, 5: スターター
 * @type {{name: string, grade: '0'|'1'|'2'|'3'|'4'|'5', max_delivery: number}}
 */
const plan = {
  name: "",
  grade: "",
  max_delivery: 0,
};

/** 
 * @type { plan: object } 
 * */
const state = {
  plan: plan,
  point_code_enable: false,
  open_tracking_enable: false,
  direct_click_enable: false,
  notification_message_enable: false,
};

const getters = {
  getGradeName( state ) {
    return getPlanGrade(state.plan.grade);
  },
  isLowerThanStarter( state ) {
    return isLowerThanStarter(state.plan.grade);
  },
  isLowerThanLight( state ) {
    return isLowerThanLight(state.plan.grade);
  },
  isLowerThanStandard( state ) {
    return isLowerThanStandard(state.plan.grade);
  },
  isLowerThanPro( state ) {
    return isLowerThanPro(state.plan.grade);
  },
  isLowerThanEnterprise( state ) {
    return isLowerThanEnterprise(state.plan.grade);
  },
  openTrackingEnable( state ) {
    return state.open_tracking_enable;
  },
  directClickEnable( state ) {
    return state.direct_click_enable;
  },
  notificationMessageEnable( state ) {
    return state.notification_message_enable;
  },
};

const mutations = {

  [types.ACCOUNT_PLAN_SET]( state, payload ) {
    state.plan.name = payload.name;
    state.plan.grade = payload.grade;
    state.plan.max_delivery = payload.max_delivery;
  },

  [types.ACCOUNT_POINT_CODE_ENABLE_SET]( state, payload ) {
    state.point_code_enable = payload.point_code_enable;
  },

  [types.ACCOUNT_OPEN_TRACKING_ENABLE_SET]( state, payload ) {
    state.open_tracking_enable = payload.open_tracking_enable;
  },

  [types.ACCOUNT_DIRECT_CLICK_ENABLE_SET]( state, payload ) {
    state.direct_click_enable = payload.direct_click_enable;
  },

  [types.ACCOUNT_NOTIFICATION_MESSAGE_ENABLE_SET]( state, payload ) {
    state.notification_message_enable = payload.notification_message_enable;
  },
};

const actions = {
  /** [payload] data.plan */
  setAccountPlan({ commit }, payload ){
    commit( types.ACCOUNT_PLAN_SET, payload );
  },
  /** [payload] data.currentAccount */
  setAccountPointCodeEnable({ commit }, payload ){
    commit( types.ACCOUNT_POINT_CODE_ENABLE_SET, payload );
  },
  setAccountOpenTrackingEnable({ commit }, payload ){
    commit( types.ACCOUNT_OPEN_TRACKING_ENABLE_SET, payload );
  },
  setAccountDirectClickEnable({ commit }, payload ){
    commit( types.ACCOUNT_DIRECT_CLICK_ENABLE_SET, payload );
  },
  setAccountNotificationMessageEnable({ commit }, payload ){
    commit( types.ACCOUNT_NOTIFICATION_MESSAGE_ENABLE_SET, payload );
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
